import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';

const WHATSAPP_E164 = '905072445204';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_E164}`;

const FloatWrapper = styled(motion.a)`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(145deg, #25d366, #128c7e);
  color: #fff;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.45), 0 2px 8px rgba(0, 0, 0, 0.15);
  text-decoration: none;
  cursor: pointer;
  transition: box-shadow 0.25s ease, transform 0.2s ease;

  &:hover {
    box-shadow: 0 6px 28px rgba(37, 211, 102, 0.55), 0 4px 12px rgba(0, 0, 0, 0.2);
    transform: scale(1.06);
  }

  &:focus-visible {
    outline: 3px solid var(--primary-color, #2d5a27);
    outline-offset: 3px;
  }

  @media (max-width: 768px) {
    bottom: 18px;
    right: 18px;
    width: 56px;
    height: 56px;
  }
`;

const PulseRing = styled(motion.span)`
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  border: 2px solid rgba(37, 211, 102, 0.6);
  pointer-events: none;
`;

const IconBox = styled.span`
  position: relative;
  z-index: 1;
  display: flex;
  font-size: 32px;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

function WhatsAppFloat() {
  return (
    <FloatWrapper
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp ile iletişime geçin: +90 507 244 52 04"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 260, damping: 20 }}
      whileTap={{ scale: 0.95 }}
    >
      <PulseRing
        animate={{ scale: [1, 1.15, 1], opacity: [0.7, 0.2, 0.7] }}
        transition={{ duration: 2.2, repeat: Infinity, ease: 'easeInOut' }}
      />
      <IconBox>
        <FaWhatsapp aria-hidden />
      </IconBox>
    </FloatWrapper>
  );
}

export default WhatsAppFloat;
